export default {
  club_name: 'Stabæk Fotball',
  club_name_short: 'stabak',
  stadium_name: '',
  staging_url: 'https://stabak.api.fangroup.io',
  prod_url: 'https://stabak.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/stabak',
  club_logo: '/assets/teams/stabak.png',
  app_name: 'stabak',
  websale_name: 'stabak',
  ntb_team_id: 10072,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'stabak',
  monolithEnabled: false,
  clubWebsiteEnabled: true,
};
